import React, { useMemo } from 'react';
import { FuelButton } from '@frete.com/fuel-react';
import { useAppContext } from '@/context';
import { Container } from './styled';

const stepTexts = ['Etapa 2: Veículo', 'Etapa 3: Viagem', 'Etapa 4: Gerenciadora de risco', 'Enviar cadastro'];

export const FormActions: React.FC = () => {
  const { state, dispatch } = useAppContext();
  const formSteps = useMemo(() => ({ ...state.formSteps }), [state.formSteps]);
  const risk = useMemo(() => ({ ...state.risk }), [state.risk]);
  const truckerProfile = useMemo(() => ({ ...state.truckerProfile }), [state.truckerProfile]);

  const showPrev = useMemo(() => {
    const prevBreak = truckerProfile.isAllAutoLoaded ? 2 : 1;
    return formSteps.current > prevBreak;
  }, [formSteps.current, truckerProfile.data]);

  const nextText = useMemo(() => {
    const realStepIndex = (formSteps.current >= formSteps.steps ? formSteps.steps : formSteps.current) - 1;
    return stepTexts[realStepIndex];
  }, [formSteps.current]);

  const disabledSubmit = useMemo(
    () => (!risk.isValid && risk.triedToSubmit) || risk.isLoadingSubmit,
    [risk.isValid, risk.triedToSubmit, risk.isLoadingSubmit],
  );

  const prevStep = () => {
    dispatch({ action: 'risk_set_tried_to_submit', payload: false });
    dispatch({ action: 'risk_set_is_valid', payload: true });
    dispatch({ action: 'form_step_prev' });
  };

  return (
    <Container>
      {showPrev && (
        <FuelButton variant="tertiary" size="large" type="button" onClick={prevStep}>
          Voltar
        </FuelButton>
      )}
      <FuelButton
        disabled={disabledSubmit}
        isLoading={risk.isLoadingSubmit}
        trailingIcon="arrow-right"
        size="large"
        type="submit"
        variant="primary"
      >
        {nextText}
      </FuelButton>
    </Container>
  );
};
